<template>
    <div>
        <Title
            class="mb-3"
            :value="axisTitle"
            :isAxisX="axis == 'x'"
            :validation="validations.axisTitle"
            @update="onUpdateProp('axisTitle', $event)"
        />
        <Variables
            class="mb-3"
            :axis="axis"
            :variables="variables"
            :isValid="validations.axisVariables"
            @update="onUpdateProp('variables', $event)"
        />
        <VariablesWeight
            v-if="variables.length"
            class="mb-3"
            :variables="variables"
            :validations="validations.variables"
            @update="
                (index, value) =>
                    onUpdateVariableProperty(index, 'result_weight', value)
            "
        />
        <div
            class="mb-4"
            :key="`variable-${index}`"
            v-for="(variable, index) in variables"
        >
            <VariableSetup
                class="mb-2"
                :variable="variable"
                :validations="validations.variables[index]"
                @update="
                    (prop, value) =>
                        onUpdateVariableProperty(index, prop, value)
                "
            />
        </div>
    </div>
</template>
<script>
import Title from './components/Title'
import Variables from './components/Variables'
import VariableSetup from './components/VariableSetup'
import VariablesWeight from './components/VariablesWeight'
export default {
    components: {
        Title,
        Variables,
        VariableSetup,
        VariablesWeight,
    },
    props: {
        axis: {
            type: String,
            required: true,
        },
        axisTitle: {
            type: String,
            default: '',
        },
        variables: {
            type: Array,
            required: true,
        },
        validations: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onUpdateProp(key, value) {
            this.$emit(`update:${key}`, value)
        },
        onUpdateVariableProperty(index, prop, value) {
            this.$emit('update-variable', index, prop, value)
        },
    },
}
</script>
